module.exports = __webpack_public_path__ + "static/media/epark-headset.4bdbebeb.svg";